
import PreEntryApi from '../../assets/js/preentry'
import { i18nHelper } from '@it-common/lbp_common'
import OnboardHeader from '../OnboardHeader'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'


export default {
components: {
XButton,
Group,
Cell,
XInput,
Loading,
Datetime,
XTextarea,
Checklist,
OnboardHeader
},
data () {
return {
id: '',
isZH: localStorage.getItem('offer_zh') === 'zh',
showLoading: true,
code: '',
name: '',
schoolRefuseReason: [],
whereReason: [],
schoolRefuseReasonAdd: '',
whereReasonAdd: '',
isSchoolRefuseReasonAddShow: false,
isWhereAddShow: false,
refuseStatus: 0,
reasonList: [],
whereList: []
}
},
created () {
this.id = this.$route.query.id


var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')
i18nHelper.loadLanguagePack(4159)
i18nHelper.setFixedLocale(localStorage.getItem('offer_zh'))
this.$forceUpdate()

if (!this.code || !this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },
(data, meta) => {
if (data && data.isSubmit === true) {
this.$router.push({
name: 'onboard.preview',
query: { id: this.id }
})
}
},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
},
err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},
err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
)
PreEntryApi.getStaffDetail({ id: this.id, code: this.code }, data => {
if (data) {
this.name = data.name ? data.name : data.candidate_name
this.showLoading = false
}
})







PreEntryApi.getWhereList(
{},
data => {
this.whereList = JSON.parse(data).map(item => {
return { key: item.desc, value: item.desc }
})
console.log(this.whereList)
},
(data, message) => {
this.$message.error(this.$tsg(message))
}
)
PreEntryApi.getRefuseReasonList(
{},
data => {
this.reasonList = JSON.parse(data).map(item => {
return { key: item.desc, value: item.desc }
})
console.log(this.reasonList)
},
(data, message) => {
this.$message.error(this.$tsg(message))
}
)
},
methods: {

getIsZh (data) {
var localStorage = window.localStorage
if (data) {
localStorage.setItem('offer_zh', 'zh')

} else {
localStorage.setItem('offer_zh', 'en')

}
this.isZH = data
},
changeSelectReason (val) {





if (val.indexOf('其他') !== -1) {




this.isSchoolRefuseReasonAddShow = true
} else {
this.isSchoolRefuseReasonAddShow = false
}
},
changeSelectWhere (val) {
if (val.indexOf('其他工作机会') !== -1) {
this.isWhereAddShow = true
} else {
this.isWhereAddShow = false
}
},
goCancel () {
this.$router.push({
name: 'onboard.school_graduate',
query: { id: this.id }
})
},
goRefuse () {
if (!this.id) {
this.$message.error(this.$tsg('非法操作。'))
return false
}

if (this.whereReason.length === 0) {
this.$message.error(this.$tsg('请选择去向'))
return false
}
if (this.schoolRefuseReason.length === 0) {
this.$message.error(this.$tsg('请选择原因'))
return false
}
console.log(this.schoolRefuseReason)
if (
this.schoolRefuseReason.indexOf('其他') !== -1 &&
this.schoolRefuseReasonAdd === ''
) {
this.$message.error(this.$tsg('请填写原因'))
return false
}
PreEntryApi.saveGiveUp(






{
archive_type: '候选人放弃我们',
archive_reason: this.schoolRefuseReason,
archive_reason_detail: this.schoolRefuseReason.indexOf('其他') !== -1 ? this.schoolRefuseReasonAdd : '',
give_up_where: this.whereReason.toString(),
give_up_where_notes: this.whereReason.indexOf('其他工作机会') !== -1 ? this.whereReasonAdd : '',
source: 'onboard',
datas: [{id: this.id, code: this.code}]
},
(data, meta, message) => {
if (message === '成功') {
this.$router.push({
name: 'onboard.campus_recruitment_refuse_success',
query: { id: this.id }
})
}
},
(data, message) => {
this.$message.error(this.$tsg(message))
}
)
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/campus_recruitment_refuse.vue